import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
let AmSelectFieldMixin = class AmSelectFieldMixin extends Vue {
  get mappedLabelField() {
    var _this$labelValueMapIn;
    return ((_this$labelValueMapIn = this.labelValueMapInfo) === null || _this$labelValueMapIn === void 0 ? void 0 : _this$labelValueMapIn.label) || 'label';
  }
  get mappedValueField() {
    var _this$labelValueMapIn2;
    return ((_this$labelValueMapIn2 = this.labelValueMapInfo) === null || _this$labelValueMapIn2 === void 0 ? void 0 : _this$labelValueMapIn2.value) || 'value';
  }
};
__decorate([Prop({
  default: false
})], AmSelectFieldMixin.prototype, "filterable", void 0);
__decorate([Prop({
  type: Array,
  default: () => []
})], AmSelectFieldMixin.prototype, "options", void 0);
__decorate([Prop(Object)], AmSelectFieldMixin.prototype, "labelValueMapInfo", void 0);
AmSelectFieldMixin = __decorate([Component({
  name: 'AmSelectFieldMixin'
})], AmSelectFieldMixin);
export default AmSelectFieldMixin;